import $ from 'jquery';

export function initPegawaiPerformance() {
    const pageId = document.getElementById('page-id')?.getAttribute('data-page');
    if (pageId !== 'pegawai_performance') return;

    if (!window.pegawaiPerformanceData) return;

    const data = window.pegawaiPerformanceData;
    const trendBulanan = data.trendBulanan;
    const metrics = data.metrics;

    const months = trendBulanan.map(x => x.month);
    const patrolData = trendBulanan.map(x => x.patrol);
    const eksekusiData = trendBulanan.map(x => x.eksekusi);
    const gangguanData = trendBulanan.map(x => x.gangguan);

    function getThemeMode() {
        return document.documentElement.getAttribute('data-bs-theme') === 'dark' ? 'dark' : 'light';
    }

    let trendChart = null;
    let donutChart = null;
    let rasioChart = null;

    // Tren Kinerja Bulanan Chart
    const trendCtx = document.querySelector("#chart-trend");
    if (trendCtx && typeof ApexCharts !== 'undefined') {
        const trendOptions = {
            series: [
                { name: 'Patrol', type: 'area', data: patrolData },
                { name: 'Eksekusi', type: 'area', data: eksekusiData },
                { name: 'Gangguan', type: 'line', data: gangguanData }
            ],
            chart: { height: 280, type: 'line', toolbar: { show: false }, fontFamily: 'Inter, sans-serif' },
            theme: { mode: getThemeMode() },
            stroke: { width: [2, 2, 3], curve: 'smooth' },
            colors: ['#10b981', '#3b82f6', '#a855f7'],
            fill: {
                type: ['gradient', 'gradient', 'solid'],
                gradient: {
                    shadeIntensity: 1,
                    opacityFrom: 0.35,
                    opacityTo: 0.05,
                    stops: [0, 90, 100]
                }
            },
            dataLabels: {
                enabled: true,
                enabledOnSeries: [2],
                formatter: function (val) { return val },
                background: { enabled: false },
                style: { fontSize: '11px', fontWeight: 600, colors: ["var(--bs-body-color)"] },
                offsetY: -10
            },
            xaxis: { categories: months, axisBorder: { show: false }, axisTicks: { show: false }, labels: { style: { fontSize: '11px', fontWeight: 500 } } },
            yaxis: { 
                title: { text: 'Jumlah', style: { fontSize: '10px', fontWeight: 500 } }, 
                labels: { style: { fontSize: '11px' } },
                min: 0
            },
            legend: { position: 'top', horizontalAlign: 'center', fontSize: '12px', markers: { radius: 12 } },
            grid: { strokeDashArray: 4 }
        };
        trendChart = new ApexCharts(trendCtx, trendOptions);
        trendChart.render();
    }

    // Proporsi Pekerjaan Chart
    const donutCtx = document.querySelector("#chart-donut");
    if (donutCtx && typeof ApexCharts !== 'undefined') {
        const donutOptions = {
            series: [metrics.patrol, metrics.eksekusi],
            chart: { type: 'donut', height: 280, fontFamily: 'Inter, sans-serif' },
            theme: { mode: getThemeMode() },
            labels: ['Patrol', 'Eksekusi'],
            colors: ['#10b981', '#f59e0b'],
            plotOptions: {
                pie: {
                    donut: {
                        size: '70%',
                        labels: {
                            show: true,
                            name: { show: true, fontSize: '12px', fontWeight: 600 },
                            value: { show: true, fontSize: '24px', fontWeight: 800 },
                            total: { show: true, showAlways: true, label: 'TOTAL', fontSize: '12px', fontWeight: 600 }
                        }
                    }
                }
            },
            dataLabels: { enabled: false },
            legend: { position: 'bottom', fontSize: '13px', markers: { radius: 12 }, itemMargin: { horizontal: 10, vertical: 8 } },
            stroke: { show: false }
        };
        donutChart = new ApexCharts(donutCtx, donutOptions);
        donutChart.render();
    }

    // Rasio Kinerja Bar Chart
    const rasioCtx = document.querySelector("#chart-rasio");
    if (rasioCtx && typeof ApexCharts !== 'undefined') {
        const pctPatrol = metrics.gangguan > 0 ? Math.round((metrics.patrol / metrics.gangguan) * 100) : 0;
        
        const totalAssignedWo = metrics.eksekusi + metrics.work_order;
        const pctEksekusi = totalAssignedWo > 0 ? Math.round((metrics.eksekusi / totalAssignedWo) * 100) : 0;
        
        const rasioOptions = {
            series: [{
                name: 'Rasio (%)',
                data: [pctPatrol, pctEksekusi]
            }],
            chart: { type: 'bar', height: 280, fontFamily: 'Inter, sans-serif', toolbar: { show: false } },
            theme: { mode: getThemeMode() },
            plotOptions: {
                bar: {
                    borderRadius: 6,
                    horizontal: false,
                    columnWidth: '45%',
                    distributed: true,
                    dataLabels: {
                        position: 'top'
                    }
                }
            },
            dataLabels: {
                enabled: true,
                formatter: function (val) { return val + "%"; },
                offsetY: -20,
                style: { fontSize: '14px', fontWeight: 700, colors: ["var(--bs-body-color)"] }
            },
            xaxis: {
                categories: ['Patrol / Gg', 'Eks / WO'],
                labels: { style: { fontSize: '13px', fontWeight: 600 } },
                axisBorder: { show: false },
                axisTicks: { show: false }
            },
            yaxis: { 
                show: false,
                max: function(max) { return max > 0 ? max * 1.15 : 100; } 
            },
            colors: ['#10b981', '#f59e0b'],
            legend: { show: false },
            grid: { show: false },
            tooltip: {
                y: { formatter: function(val) { return val + '%'; } },
                theme: getThemeMode()
            }
        };
        rasioChart = new ApexCharts(rasioCtx, rasioOptions);
        rasioChart.render();
    }

    // Dynamic Theme Update
    const observer = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
            if (mutation.type === 'attributes' && mutation.attributeName === 'data-bs-theme') {
                const newTheme = getThemeMode();
                if (trendChart) trendChart.updateOptions({ theme: { mode: newTheme } });
                if (donutChart) donutChart.updateOptions({ theme: { mode: newTheme } });
                if (rasioChart) rasioChart.updateOptions({ theme: { mode: newTheme }, tooltip: { theme: newTheme } });
            }
        });
    });
    observer.observe(document.documentElement, { attributes: true });
}
